module.exports = __webpack_public_path__ + "img/us_2.85d99eec.png";